import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RedirectCommand,
  Router,
} from '@angular/router';
import { Languages } from '../languages';
import { iirdsStore } from '../stores/iirds.store';
import { logGuardResult } from './guard-logger';

export const validLanguageGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const iirds = inject(iirdsStore);
  const router = inject(Router);
  const language = route.params['language'];
  if (!iirds.languages().includes(language)) {
    if (language === Languages.UND) {
      return logGuardResult('validLanguageGuard', true, {
        reason: 'language is UND (undefined), allowed as-is',
      });
    }
    return logGuardResult(
      'validLanguageGuard',
      new RedirectCommand(
        router.createUrlTree(['iirds'], {
          queryParams: {
            reset: true,
          },
        })
      ),
      {
        reason: 'language not supported by iirds metadata',
        language,
        supportedLanguages: iirds.languages(),
      }
    );
  }
  return logGuardResult('validLanguageGuard', true, {
    reason: 'language supported by iirds metadata',
    language,
  });
};
